export const inventory = {
  main: "Inventory",
};
